import { styled, width } from "@mui/system";
import Typography from "@mui/material/Typography";
import useMediaQuery from "@mui/material/useMediaQuery";
import TopBar from "../components/TopBar";
import Main from "../components/Main";

const Wrapper = styled("div")(({ theme }) => ({
  maxWidth: "100%",
  margin: "0 0",
  height: "100%",

  [theme.breakpoints.down("xs")]: {
    maxWidth: "100%",
  },
  [theme.breakpoints.down("sm")]: {
  background:
    "no-repeat url(./images/bg1.png) 19px 403px/324px,no-repeat url(./images/bg2.png) 144px 691px/233px,no-repeat"
   },
  // [theme.breakpoints.up("sm")]: {
  //   background:
  //     "no-repeat url(./images/bg1.png) 100px 229px/692px,no-repeat url(./images/bg2.png) right 2px/293px,no-repeat"
  //  },
}));

export default function Home() {
  const isSmallScreen = useMediaQuery("(max-width: 900px)");
  return (
    <Wrapper>
      <TopBar />
      <Main />
      <Typography
        style={
          isSmallScreen
            ? { marginTop: "40px", textAlign: "center" }
            : { marginTop: "60px", textAlign: "center" }
        }
      ></Typography>
    </Wrapper>
  );
}
